import React, { FC } from 'react'

import { ActionButtonProps } from '../../components/ActionButton'
import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'

import * as SC from './styled'

export type ReasonProps = {
  text: string
}

export type NotFoundTemplateProps = {
  layout?: DefaultLayoutProps
  title?: string
  description?: string
  cta?: ActionButtonProps
}

const NotFoundTemplate: FC<NotFoundTemplateProps> = ({ layout, title, description, cta }) => {
  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <SC.Title>{title}</SC.Title>
        <SC.Description>{description}</SC.Description>
        {cta && <SC.Cta variant="link" {...cta} />}
      </SC.Content>
    </DefaultLayout>
  )
}

export default NotFoundTemplate
